module.exports = __webpack_public_path__ + "media/images/application/template/logo-reviews-io-8dc89094239989ad5e7af973ed931188.svg";